import Mutations from '../../odata/mutations';

export default { ...new Mutations('shareOfVoiceRecommendation'), ...new Mutations('shareOfVoiceRecommendations') };
